import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

export class OrderDetails extends Component {
    
	constructor(props) {
        super(props);        
    }
	
	render() {
        return (
            <div className={this.props.clssName}>
			    <div className="order-details p-4 bg-white">
			        <div className="table-responsive">
			            <table className="table table-borderless m-0">
			    	        <thead>
			    	    	    <tr>
			    	    	        <th className="py-2 px-0">
			    	    	    	    Product
			    	    	    	</th>
			    	    	    	<th className="py-2 px-0 text-right">
			    	    	    	    Total
			    	    	    	</th>
			    	    	    </tr>
			    	    	</thead>
			    	    	<tbody>
			    	    	    <tr>
			    	    	        <td className="pt-2 pb-3 px-0">
										$1 for 7 days
			    	    	    	</td>
			    	    	    	<td className="pt-2 pb-3 px-0 text-right">
			    	    	    	    $1.00
			    	    	    	</td>
			    	    	    </tr>
			    	    	</tbody>
			    	    	<tfoot>
			    	    	    <tr>
			    	    	        <td className="px-0">
			    	    	    	    Total:
			    	    	    	</td>
			    	    	    	<td className="px-0 text-right">
			    	    	    	    $1.00
			    	    	    	</td>
			    	    	    </tr>
			    	    	</tfoot>
			    	    </table>
			    	</div>	
			    	<p className="mb-1">After your trial you will be charged</p>
                    <p>$199 yearly until cancelation. <span className="font-weight-bold">Cancel anytime</span>.</p>
			    </div>
			</div>
		);
        
    }
}

OrderDetails.contextType = AppContext;
export default OrderDetails;



// WEBPACK FOOTER //
// ./src/components/general/include/OrderDetails.js